const Infobox = require("components/mixins/Infobox");
const Form = require("components/forms/Form");
const Input = require("components/forms/Input");
const RichTextarea = require("components/forms/RichTextarea");
const Textarea = require("components/forms/Textarea");
const Date = require("components/forms/Date");
const Phone = require("components/forms/Phone");
const Address = require("components/forms/Address");
const Section = require("components/forms/Section");
const Achievement = require("components/forms/Achievement");
const MobileAvatar = require("components/backend/MobileAvatar");
const IntegerField = require("components/forms/IntegerField");
const Url = require("components/forms/Url");
const Tags = require("components/forms/Tags");
const Price = require("components/forms/Price");
const Qualifications = require("components/forms/Qualifications");
const store = require("stores/UserStore");
const env = require("services/env");
const moment = require("moment");
const {observer} = require("mobx-react");
const router = require("services/router");
const CampaignPrices = require("components/forms/CampaignPrices");
const {decodeObservable} = require("helpers/object");
const assign = require("object-assign");
const {roundToFives} = require("helpers/format");
const shortid = require("shortid");
const Checkbox = require("components/forms/Checkbox");
const Load = require("components/mixins/Load");
const Modal = require("components/modals/Modal");
const {classList} = require("helpers/html");

@observer
class TeacherProfileForm extends Form {

	constructor(props) {
		super(props);

		assign(this.state, {
			priceChanges: {},
			approve: false,
			loadingApproval: false
		});
	}

	/////////////////////////////////
	// Methods
	/////////////////////////////////

	handleErrors(errors) {
		this.setState({
			loading: false,
			loadingApproval: false,
			message: null,
			errors: errors
		}, () => {
			if (this.state.approve) {
				this.approvalErrorModal.open();
			}
		});
	}

	handleSuccess(message) {
		this.setState({
			loading: false,
			loadingApproval: false,
			message: message,
			errors: {}
		}, () => {
			if (this.state.approve) {
				this.approvalSuccessModal.open();
			}
		});
	}

	onSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();

		this.setState({approve: false}, () => {
			this.submit();
		});
	};

	onSubmitForApproval = (e) => {
		e.preventDefault();
		e.stopPropagation();

		this.setState({approve: true, loadingApproval: true}, () => {
			this.submit();
		});
	};

	/////////////////////////////////
	// Accessors
	/////////////////////////////////

	get successMessage() {
		return "Dine profiloplysninger er blevet opdateret.";
	}

	get actionLabel() {
		return "Gem";
	}

	get shouldWarn() {
		return true;
	}

	get assignedLevels() {
		return Array.from(this.value("levels", []));
	}

	get assignedSubjects() {
		return Array.from(this.value("subjects", []));
	}

	get requiredIfApprovalStage() {
		return true;
	}

	get maxBirthdayDate() {
		return moment().toISOString();
		// TODO: Add proper limit
		//return moment().subtract(18, "years").toISOString();
	}

	get campaignPrices() {
		return decodeObservable(this.value("prices", []).filter(price => price.type === "campaign"));
	}

	get loading() {
		return this.state.loading || this.state.loadingApproval;
	}

	get className() {
		return classList(
			super.className,
			this.state.loadingApproval && "loading-approval"
		);
	}

	/////////////////////////////////
	// Methods
	/////////////////////////////////

	send(form) {
		let data = new FormData(form);

		for (i = 0; i < form.elements.length; i++) {
			let input = form.elements[i];

			if (input.type === 'file' && input.files.length === 0) {
				data.delete(input.name);
			}
		}

		return store.save(data);
	}

	value(name, defaultValue = null) {
		return store.get(name, defaultValue);
	}

	priceChangeValue(hours) {
		return this.state.priceChanges[hours];
	}

	getPricePrediction(hours) {
		const normalValue = this.priceChangeValue(1);

		if (normalValue == undefined) {
			return;
		}

		let res;

		switch (hours) {
			case 10:
				res = roundToFives(normalValue * 0.95);
				break;

			case 20:
				res = roundToFives(normalValue * 0.9);
				break;

			case 40:
				res = roundToFives(normalValue * 0.85);
				break;

			default:
				res = normalValue;
		}

		return res < 120 ? 120.0 : res;
	}

	/////////////////////////////////
	// Listeners
	/////////////////////////////////

	priceChangeListener(hours) {
		return (value) => {
			this.setState(state => {
				state.priceChanges[hours] = value;
				return state;
			});
		};
	}

	/////////////////////////////////
	// Renderers
	/////////////////////////////////

	renderHeader() {
		if (this.value("registration_status") === "registered") {
			return (
				<Infobox>
					<p><span>OBS!</span> Udfyld venligst dine profiloplysninger, inden du kan blive godkendt som underviser.</p>
				</Infobox>
			);
		}

		if (this.value('needsStripeTos')) {
			return (
				<Infobox>
					<p><span>OBS!</span> Vær opmærksom på, at du skal acceptere Stripes serviceaftale nederst på siden, før vi kan foretage udbetalinger til dig.</p>
				</Infobox>
			);
		}

		if (this.value("registration_status") === "rejected") {
			const rejection = this.value("rejection_reason");
			const reason = rejection !== null ?
				(
				<React.Fragment>
					<br />
					<p><span>Begrundelse:</span></p>
					<p>{rejection}</p>
					<br />
				</React.Fragment>
				) :
				null;

			return (
				<Infobox clssName="red">
					<p><span>OBS!</span> Din andmodning til godkendelse som underviser er blevet afvist.</p>
					{reason}
					<p>Når du har opfyldt alle kravene, er du velkommen til at andmode om godkendelse igen.</p>
				</Infobox>
			);
		}
	}

	renderApprovalError() {
		const errors = this.state.errors;
		const errorsMarkup = Object.keys(errors).map(key => {
			const message = errors[key][0];

			return (
				<p className="error" key={key}>{message}</p>
			);
		});

		return (
			<Modal className="approval-modal" ref={el => this.approvalErrorModal = el}>
				<p className="approval-title">Følgende felter mangler og kræves til godkendelse:</p>
				{errorsMarkup}
			</Modal>
		);
	}

	renderApprovalSuccess() {
		return (
			<Modal ref={el => this.approvalSuccessModal = el}>
				<p className="approval-message">Din profil er blevet sendt til godkendelse.</p>
			</Modal>
		);
	}

	renderApproval() {
		return (
			<div className="teacher-approval">
				<input type="hidden" name="approve" value={this.state.approve ? 1 : 0}/>
				{this.renderApprovalError()}
				{this.renderApprovalSuccess()}
			</div>
		);
	}

	renderActions() {
		let regStat = store.get("registration_status");

		if (regStat === "registered" || regStat === "rejected") {
			return (
				<button type="button" className="btn approve-btn" disabled={this.loading} onClick={this.onSubmitForApproval}>
					Send min profil til godkendelse
					<Load></Load>
				</button>
			);
		}
	}

	renderAvatar() {
		return (
			<label className="field only-mobile">
				<p className="label">Profilbillede</p>
				<MobileAvatar />
			</label>
		);
	}

	renderBody() {
		return (
			<div className="form-body">
				<Section title="Generelle informationer">
					<Input label="Fulde navn" type="text" name="name" required={true}
								 defaultValue={this.value("name")} error={this.error("name")}/>

					<Address types="address" componentRestrictions={{country: "dk"}}
									 label="Adresse" name="address" autoComplete="user-address" required={true}
									 defaultValue={this.value("address")} error={this.error("address")} placeholder=""/>

					<Input label="Email" type="email" name="email" required={true}
								 defaultValue={this.value("email")} error={this.error("email")} autoComplete={shortid.generate()}/>

					<Phone label="Telefon" name="phone" required={true}
								 defaultValue={this.value("phone")} error={this.error("phone")}/>

					<Date label="Fødselsdag" type="text" name="birthday" required={true}
								max={this.maxBirthdayDate} defaultValue={this.value("birthday")} error={this.error("birthday")}/>

					{this.renderAvatar()}

					{this.renderCriminalRecordField()}
					<Input type="hidden" name="avatar"></Input>

					<RichTextarea className="full-width" label="Beskrivelse" name="description"
												placeholder="Udfyld en beskrivelse af dig selv" afterChange={this.setWarning}
												defaultValue={this.value("description")} error={this.error("description")}/>

					<Textarea label="Din personlige hilsen til eleven når de booker dig" className="full-width" name="thank_you_msg"
								 defaultValue={this.value("thank_you_msg")} error={this.error("thank_you_msg")}/>

				</Section>
				<Section title="Undervisning">
					<Qualifications className="full-width space-between" required={this.requiredIfApprovalStage}
													levelsError={this.error("levels")}
													afterChange={this.setWarning}
													subjectsError={this.error("subjects")}
													levels={this.assignedLevels} subjects={this.assignedSubjects}/>
				</Section>
				<Section title="Uddannelse">
					{this.renderAchievementFields()}
					{/*<Url className="full-width" label="Profil URL" name="username" required={true}
					 prefix={router.route("profile", {username: ""}) + "/"}
					 defaultValue={this.value("username")} error={this.error("username")}/>*/}
				</Section>
				<Section title="Timepris">
					<div className="price-fields">
						{this.renderPriceFields()}
					</div>
				</Section>
				<Section title="Undervisningspris i eksamensperioder">
					<p className="section-sub-title">Hvis du ønsker at tage en højere timepris end normalt i specielt travle
						perioder</p>
					<CampaignPrices name="campaigns" error={this.errors("campaigns")} value={this.campaignPrices}/>
				</Section>
				{this.renderTos()}
				{this.renderApproval()}
			</div>
		);
	}

	renderCriminalRecordField() {
		const criminalRecord = this.value("criminal_record");
		const linkMarkup = criminalRecord ? (
			<a className="view-current" target="_blank" href={criminalRecord.url}>Se nuværende</a>) : null;

		return (
			<Input type="file" label="Straffeattest" name="criminal_record"
						 error={this.error("criminal_record")}
						 required={this.requiredIfApprovalStage} accept="application/pdf,image/*">
				{linkMarkup}
			</Input>
		);
	}

	renderPriceFields() {
		const prices = env.get("options.priceHours", []);
		const userPrices = this.value("prices", []);

		const value = (hours, type = "normal") => {
			const price = userPrices.filter(userPrice => (userPrice.min_hours === hours) && (userPrice.type === type)) [0];
			return price ? price.rate : null;
		};

		// Add price for hours
		let priceMarkup = prices.map(hours => {
			const label = hours === 1 ? "Normal timepris" : `Timepris ved køb af ${hours} timer`;
			const required = this.requiredIfApprovalStage && (hours === 1);
			const handleChange = this.priceChangeListener(hours);
			let priceValue = this.priceChangeValue(hours);

			if (priceValue == undefined) {
				priceValue = value(hours);
			}

			if (priceValue == undefined) {
				priceValue = this.getPricePrediction(hours);
			}

			return (
				<Price key={hours} name={`prices[${hours}]`} value={priceValue} label={label} required={required}
								handleChange={handleChange} error={this.error(`prices.${hours}`)}>
					<p className="sublabel" title="Dette er prisen som bliver vist til eleven">
						Inklusiv servicegebyr: {(priceValue || 0) + this.value('teacherFee', 10)},-
					</p>
				</Price>
			);
		});

		// Add price for extra student
		priceMarkup = priceMarkup.slice(0, 1).concat([

			<Price key="extra_student" name="prices[extra_student]" defaultValue={value(1, "extra_student")}
						 required={this.requiredIfApprovalStage} label="Tillæg ved mere end 1 elev"
						 error={this.error("prices.extra_student")}/>

		]).concat(priceMarkup.slice(1));

		return priceMarkup;
	}

	renderAchievementFields() {
		const achievement = type => {
			return this.value("achievements", []).filter(entry => entry.type === type) [0];
		};

		const certificate = achievement("certificate") || {};
		const proficiency = achievement("proficiency") || {};
		const occupation = achievement("occupation") || {};
		const attachmentRequired = this.requiredIfApprovalStage && (certificate.attachment == undefined);

		return (
			<div className="achievement-fields-wrapper">
				<Achievement name="achievements[certificate]" required={this.requiredIfApprovalStage}
										 attachmentRequired={attachmentRequired} value={certificate}
										 error={this.errors("achievements.certificate")}/>
				<IntegerField label="Undervisningserfaring (år)" name="achievements[proficiency]"
											required={this.requiredIfApprovalStage}
											value={proficiency.value || ""} error={this.error("achievements.proficiency")}/>
				<Input label="Nuværende job/uddannelse" defaultValue={occupation.value || ""} name="achievements[occupation]"
							 error={this.error("achievements.occupation")}/>
			</div>
		);
	}

	renderTos() {
		if (!this.value('needsStripeTos')) return;

		return (
			<Section title="Vilkår og betingelser for betalingsformidling" subtitle="For at kunne håndtere udbetalinger til dig som underviser, kræver det at du acceptere betingelserne fra betalingsløsningen Stripe.">
				<a className="service-agreement" target="_blank" href="https://stripe.com/dk/connect-account/legal">Stripe Services Agreement</a>
				<div className="checkbox-wrap">
					<Checkbox name="stripe_tos" label="Jeg bekræfter, at jeg har læst og accepteret Stripes Servicesaftale" checked={false} />
				</div>
			</Section>
		);
	}
}

module.exports = TeacherProfileForm;



// WEBPACK FOOTER //
// ./resources/js/components/backend/TeacherProfileForm.js